<template>
    <div class="container">
        <h1>{{ title }}</h1>
        <p>{{ desc }}</p>
        <hr>
        <b-button variant="primary" :disabled="isLoading" @click="exportCSV">
            {{ isLoading ? 'Downloading...' : 'Download Export' }}
        </b-button>
    </div>
</template>

<script>
import ExportDataService from '@/services/ExportDataService';

export default {
    props: ['company'],
    data() {
        return {
            title: 'Export Mailing List',
            desc: 'You are about to export a list of people and their mailing address. A CSV export will automatically download.',
            api: 'mailinglist', // Default API method
            isLoading: false,
        };
    },
    created() {
        // Adjust title, description, and API method based on the route name
        if (this.$route.name === 'export_policies') {
            this.title = 'Export Active Policies';
            this.desc = 'You are about to export a list of active policies. A CSV export will automatically download.';
            this.api = 'policies';
        }
    },
    methods: {
        async exportCSV() {
  this.isLoading = true;

  try {
    // Fetch the CSV data from the API
    const response = await ExportDataService[this.api]();

    // Create a Blob from the response data
    const csvBlob = new Blob([response], { type: 'text/csv;charset=utf-8;' });

    // Set the file name based on the current date and `this.api`
    const date = new Date().toISOString().split('T')[0]; // Get current date in YYYY-MM-DD format
    const fileName = `${date}-${this.api}.csv`;

    // Create a download link
    const url = window.URL.createObjectURL(csvBlob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);

    // Trigger download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Revoke the URL to release memory
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading the file:', error);
    alert('Failed to download the file. Please try again.');
  } finally {
    this.isLoading = false;
  }
}


    },
};
</script>

<style scoped>
.container {
    margin-top: 20px;
}
</style>